module.exports = __webpack_public_path__ + "img/no-messages-files-background.a75a2e30.png";